import React, { useEffect, useState } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';

function EmpoyledOrStudying(props) {
  const [show, setShow] = useState(false);
  const [studability, setStudability] = useState({});
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { getStudability } = props;

  useEffect(() => {
    async function fetchData() {
      const studabilityData = await getStudability();
      setStudability(studabilityData);
    }
    fetchData();
  }, [getStudability]);

  const { totalUsers, totalStudying } = studability;
  const studabilityPercentage = Number(
    (totalStudying / totalUsers) * 100
  ).toFixed(0);
  return (
    <>
      <a className="nav-link link" onClick={handleShow}>
        Taxa de estudabilidade
      </a>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Taxa de estudabilidade</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table responsive bordered style={{ width: `${100}%` }}>
            <tbody>
              <tr>
                <td>Taxa de estudabilidade</td>
                <td>{studabilityPercentage}%</td>
              </tr>
              <tr>
                <td>Colaboradores que estão estudando</td>
                <td>{totalStudying}</td>
              </tr>
              <tr>
                <td>Total de colaboradores ativos</td>
                <td>{totalUsers}</td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EmpoyledOrStudying;
